export const ChevronDown = ({ className, isOpen }: { className?: string; isOpen: boolean }) => (
  <svg
    className={`${className} transition-transform duration-200 ${isOpen ? 'rotate-180' : 'rotate-0'}`}
    width="14"
    height="8"
    viewBox="0 0 14 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.90625 6.90625C6.71875 7.09375 6.375 7.09375 6.1875 6.90625L0.1875 0.90625C0 0.71875 0 0.375 0.1875 0.1875C0.375 0 0.71875 0 0.90625 0.1875L6.5625 5.84375L12.1875 0.1875C12.375 0 12.7188 0 12.9062 0.1875C13.0938 0.375 13.0938 0.71875 12.9062 0.90625L6.90625 6.90625Z"
      fill="currentColor"
    />
  </svg>
);
